import { useMutation, useQueryClient } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import i18n from 'Lib/i18n'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { AdSet } from '../models'

interface SetSelectedFacebookAdSetsResponse {
  failedAdSets: AdSet[]
  protectedAdSets: AdSet[]
}

export const setSelectedFacebookAdSets = async (
  accountId: number,
  connectionId: number,
  adAccountId: number,
  adSetIds: number[]
) => {
  return await request<SetSelectedFacebookAdSetsResponse>({
    url: `/accounts/${accountId}/facebook/${connectionId}/ad-accounts/${adAccountId}/ad-sets/selected`,
    method: 'PUT',
    data: { adSetIds },
    onSuccessToast: {
      message: i18n.t('meta-connection-wizard.adsets-successfully-connected', {
        ns: 'PMPlatforms',
      }),
      type: 'success',
    },
  })
}

export const useSetSelectedFacebookAdSets = ({ connectionId }: { connectionId: number }) => {
  const { accountId } = useUserStore()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['setSelectedFacebookAdSets'],
    mutationFn: ({ adSetIds, adAccountId }: { adAccountId: number; adSetIds: number[] }) =>
      setSelectedFacebookAdSets(accountId, connectionId, adAccountId, adSetIds),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['getUserDomains'] })
      void queryClient.invalidateQueries({ queryKey: ['domains'] })
      void queryClient.invalidateQueries({ queryKey: ['getPlatforms'] })
    },
  })
}
